export var cilCaretTop = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M496,400.357H16.333V363.908L256.047,96,496,365.81Zm-440.708-32H455.441L255.975,144.07Z' class='ci-primary'/>"];
